import UserStatsSection from '../user-stats-section';
import ParamountItem from './paramount-item';
import Achievements from '../achievements';
import { useMatrixCommercial } from '../../hooks/use-matrix-commercial';
import CardMarketing from '@ifit/mp-card-marketing';
import { DefaultImages } from '@ifit/img/out/defaults';
import './index.scss';
import { Text } from './text';
import { logout } from '../../util/navigation-utils';
import { getResizedImageUrl } from '../../util/get-resized-image-url';

export default function Hero(): JSX.Element {
  const isMatrixCommerical = useMatrixCommercial();

  const image = getResizedImageUrl('https://img.ifit.com/assets/matrix-commercial.jpg', DefaultImages.Hero, {
    height: 480,
    width: 800,
  });

  return (
    <div className="hero">
      <ParamountItem />

      {isMatrixCommerical ? (
        <div className="hero-details">
          <CardMarketing
            description={Text.description}
            imageUrl={image}
            leadLine={Text.leadline}
            title={Text.title}
            onClick={logout}
            className="matrix-commercial-marketing"
          />
        </div>
      ) : (
        <div className="hero-details">
          <UserStatsSection />
          <Achievements />
        </div>
      )}
    </div>
  );
}
